// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../node_modules/css-loader/index.js??ref--5-1!../../../node_modules/postcss-loader/lib/index.js??ref--5-2!./photo_canvas_preview.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../node_modules/vue-style-loader/lib/addStylesClient.js")("14eff454", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/photo_canvas_preview.css
// module id = E1F2
// module chunks = 2